import $ from 'jquery';

import application from 'application/application';

application

	.directive('ngValidate', ['$timeout', 'validationFeedbacks', ($timeout, validationFeedbacks) => ({
		restrict: 'A',
		link(scope, element, attributes) {

			const formName = attributes.name;
			const form = scope[formName];

			scope.$resetFormValidation = formName => {

				return () => {

					$('input,textarea,select').filter((index, input) => input.form && input.form.name === formName)

						.removeClass('is-invalid is-valid');

				};

			};

			$timeout(() => {

				const isFormElement = element && element[0] && /^form$/i.test(element[0].tagName);

				if (!isFormElement || !form)
					return;

				element

					.on('input change click', event => {

						if (!event.target || !event.target.name)
							return;

						let control = form[event.target.name];

						if (
							(/^(?:input|textarea)$/i.test(event.target.tagName) && /(?:input|keyup)$/i.test(event.type))
							||
							(/^(?:radio|checkbox)$/i.test(event.target.type) && event.type === 'click')
							||
							(event.target.tagName === 'SELECT' && event.type === 'change')
						) {

							if (typeof control === 'object') {

								let input = $(`[name="${control.$name}"]`).filter((index, input) => input.form && input.form.name === formName);

								input

									.removeClass(control.$valid ? 'is-invalid' : 'is-valid')

									.addClass(control.$valid ? 'is-valid' : 'is-invalid')

									.attr('aria-invalid', control.$invalid);

								let feedback = '';

								if (!input.next('.invalid-feedback')[0])

									input.after($('<div />').addClass('invalid-feedback'));

								if (Array.isArray(validationFeedbacks.invalid)) {

									let match = validationFeedbacks.invalid.find(value => control.$error[value.type]) || {};

									if (match.feedback)

										feedback = match.feedback;

								}

								input.next('.invalid-feedback').text(feedback);

							}

						}

					})

					.on('submit', event => {

						event.preventDefault();

						if (!Array.isArray(form.$$controls))
							return;

						form.$$controls.forEach(control => {

							let input = $(`[name="${control.$name}"]`).filter((index, input) => input.form && input.form.name === formName);

							input

								.removeClass(control.$valid ? 'is-invalid' : 'is-valid')

								.addClass(control.$valid ? 'is-valid' : 'is-invalid')

								.attr('aria-invalid', control.$invalid);

							let feedback = '';

							if (!input.next('.invalid-feedback')[0])

								input.after($('<div />').addClass('invalid-feedback'));

							if (Array.isArray(validationFeedbacks.invalid)) {

								let match = validationFeedbacks.invalid.find(value => control.$error[value.type]) || {};

								if (match.feedback)

									feedback = match.feedback;

							}

							input.next('.invalid-feedback').text(feedback);

						});

					});

			});

		}
	})]);
